<script setup lang="ts">
import { X } from "lucide-vue-next"
import type { HTMLAttributes } from "vue"
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "~/components/ui/dialog"
import { Drawer, DrawerClose, DrawerContent, DrawerDescription, DrawerTitle } from "~/components/ui/drawer"
import { useMedia } from "~/composables/media"
import { cn } from "~/lib/utils"
import { ContactForm } from "."

const { class: cl } = defineProps<{
    class?: HTMLAttributes["class"]
}>()

const open = defineModel("open", { type: Boolean, default: false })

const { isDesktop } = useMedia()
</script>
<template>
    <Dialog 
        v-if="isDesktop"
        v-model:open="open"
    >
        <DialogContent
            :class="cn('size-full max-w-none bg-foreground text-background sm:rounded-none border-none p-0 [&>button:focus-visible]:!outline-background', cl)"
        >
            <DialogTitle class="sr-only">
                Contact Us
            </DialogTitle>
            <DialogDescription class="sr-only">
                Contact form
            </DialogDescription>
            <div
                class="size-full max-h-screen overflow-y-auto"
                :style="{ background: 'var(--contact-dialog-background, inherit)', color: 'var(--contact-dialog-foreground, inherit)' }"
            >
                <div class="max-w-2xl mx-auto px-6 py-12">
                    <ContactForm />
                </div>
            </div>
        </DialogContent>
    </Dialog>
    <Drawer
        v-else
        v-model:open="open"
    >
        <DrawerContent
            :class="cn('max-h-[95svh] [&>:first-child]:shrink-0 bg-foreground text-background border-none', cl)"
        >
            <DrawerTitle class="sr-only">
                Contact Us
            </DrawerTitle>
            <DrawerDescription class="sr-only">
                Contact form
            </DrawerDescription>
            <DrawerClose
                class="absolute right-4 top-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                aria-label="Close dialog"
            >
                <X class="size-4" />
            </DrawerClose>
            <div
                class="size-full max-h-screen overflow-y-auto p-4"
                :style="{ background: 'var(--contact-dialog-background, inherit)', color: 'var(--contact-dialog-foreground, inherit)' }"
            >
                <ContactForm :title-as="DrawerTitle" />
            </div>
        </DrawerContent>
    </Drawer>
</template>